function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PALETTE_DATA = {
  light: {
    boxShadow: '0px 0px 4px rgba(9, 10, 12, 0.16)'
  },
  dark: {
    color: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)'
  }
};
export var getMenuListStyles = function getMenuListStyles(props) {
  var palette = props.palette,
      _props$maxHeight = props.maxHeight,
      maxHeight = _props$maxHeight === void 0 ? '320px' : _props$maxHeight;
  return _objectSpread({
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: '20px',
    borderRadius: '4px',
    maxHeight: maxHeight,
    overflow: 'auto',
    zIndex: 'menu',
    //ToDo: Add and correct global scroll bar styles
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '1px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888'
    }
  }, PALETTE_DATA[palette]);
};